import type { AgentRolesType } from "@/utils";
import { privateAPI, publicAPI } from "./axios";

export interface SignUpRequest {
  name: string;
  password: string;
  invitationCode: string;
}

export interface ResetPasswordRequest {
  password: string;
  token: string;
}

export interface LogInRequest {
  email: string;
  password: string;
}

export interface AuthenticationResponse {
  data: {
    accessToken: string;
    expiresIn: number;
    tokenType: string;
    message?: string;
  };
}

export interface TwoFactorAuthenticationResponse {
  data: {
    accessToken: string;
    expiresIn: number;
    tokenType: string;
    userRole: AgentRolesType;
    userName: string;
    message?: string;
  };
}

export interface TwoFactorAuthResponse {
  data: {
    message: string;
    qr: string;
    recoveryCodes: string[];
  };
}

export interface ConfirmTwoFactorAuthResponse {
  data: {
    message: string;
    accessToken: string;
  };
}

export interface ForgotPasswordRequest {
  email: string;
}

export const logout = async () => {
  const res = await privateAPI.post<null>(`/logout`, {});
  return res.data;
};

export const login = async (body: LogInRequest) => {
  const { data } = await publicAPI.post<AuthenticationResponse>("/login", {
    ...body,
  });
  return data;
};

export const enableTwoFactorAuth = async () => {
  const { data } = await privateAPI.post<TwoFactorAuthResponse>("/2fa");
  return data;
};

export const confirmTwoFactorAuth = async (code: string) => {
  const { data } = await privateAPI.post<ConfirmTwoFactorAuthResponse>(
    "/2fa/confirm",
    { code },
  );
  return data;
};

export const challengeTwoFactorAuth = async (code: string) => {
  const { data } = await privateAPI.post<TwoFactorAuthenticationResponse>(
    "/2fa/challenge",
    { code },
  );
  return data;
};

export const challengeTwoFactorRecoveryCode = async (code: string) => {
  const { data } = await privateAPI.post<TwoFactorAuthenticationResponse>(
    "/2fa/recover",
    { code },
  );
  return data;
};

export const signUp = async (body: SignUpRequest) => {
  const { data } = await publicAPI.post<AuthenticationResponse>("/users", {
    ...body,
  });
  return data;
};
